module.exports = __webpack_public_path__ + "static/media/affordable-catering-2.c709bcef.jpg";